import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ButtonStyled = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  borderRadius: '12px !important',
  padding: '10px 24px',
  [theme.breakpoints.up('md')]: {
    width: 'auto'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.background.grey.main
  }
}));

export const InfoContainer = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  padding: '24px 16px 40px 16px',
  borderRadius: '12px',
  [theme.breakpoints.up('md')]: {
    padding: '36px 32px'
  }
}));

export const CaptionTitle = styled(Text)(({ theme }) => ({
  textTransform: 'capitalize',
  [theme.breakpoints.up('md')]: {
    fontSize: '0.8125rem;',
    lineHeight: '1rem'
  }
}));

export const CaptionDescription = styled(Text)(({ theme }) => ({
  ...theme.typography.xl,
  [theme.breakpoints.up('md')]: {
    ...theme.typography.lg
  }
}));
